import { render, staticRenderFns } from "./saldodeposito.vue?vue&type=template&id=07055a30&scoped=true&"
import script from "./saldodeposito.vue?vue&type=script&lang=js&"
export * from "./saldodeposito.vue?vue&type=script&lang=js&"
import style0 from "./saldodeposito.vue?vue&type=style&index=0&id=07055a30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07055a30",
  null
  
)

export default component.exports